import { ConfirmEmail } from "./ConfirmEmailPage"
import ForgotPassword from "./forgotPassword.page"
import Login from "./login.page"
import { NewPasswordPage } from "./newPassword.page"
import { ResetPasswordPage } from "./resetPassword.page"

export { ConfirmEmail, ForgotPassword, Login, NewPasswordPage, ResetPasswordPage }
